/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DismissBadgeRequest} from '@cash-web/protos/squareup/cash/app/dismiss_badge.pb'
import {DismissBadgeResponse} from '@cash-web/protos/squareup/cash/app/dismiss_badge.pb'


export const dismissBadge = (request: DismissBadgeRequest, options?: CashRequestOptions) => post<DismissBadgeRequest, DismissBadgeResponse>("/2.0/cash/dismiss-badge", request, {...options, rejectOnError: true })